import moment from 'moment';

export const grantSiImpersonationUntil = `SI staff can only view limited data about your account. In order to troubleshoot issues or to discuss your settings, you can grant SI employees wider access to your account. Set a date to automatically revoke this permissions after a while.`;

export const euAllowExternalServices = `Allow our application to exchange data with select 3rd party services while ensuring compliance with EU regulations. 
This may include usage statistics and bug reports to help improve the service.`;

export const notifyReviewersEveryNHours = `Notify newly approved 360° Feedback reviewers by email every x hours at most. Default is 1. Select 12
                for instance and email notifications are only sent every 12 hours - meaning less timely notifications,
                but higher chance of reviewers receiving a smaller number of batched notifications.`;

export const endofBusinessHour = `
    EOB will be used as default for milestones in reviews and feedback processes, but can still be changed on a case by case basis.`;

export const timeFormat = (dateTimeFormat: string) => `
    Sample: The current date and time is ${moment().format(dateTimeFormat)}.`;

export const timezone = `We suggest you choose the most western timezone with a substantial number of staff.`;
